export default __webpack_public_path__ + "static/media/coke.d1d51dad.svg";